export const sortOptionsByOptionNameHandler = (optionSetItems) => {
  return optionSetItems.sort(function (a, b) {
    if (a.optionName > b.optionName) {
      return 1
    }
    if (b.optionName > a.optionName) {
      return -1
    }
    return 0
  })
}

export const sortOptionsSetByItemId = (optionsSet) => {
  return optionsSet.sort(function (a, b) {
    if (a.itemId > b.itemId) {
      return 1
    }
    if (b.itemId > a.itemId) {
      return -1
    }
    return 0
  })
}

export const comparisonIdGenerator = (sortedOption, selectedItemId) => {
  let comparisonId = selectedItemId

  sortedOption.forEach((option) => {
    comparisonId += option.optionName

    option.optionSet.forEach((optionSet) => {
      comparisonId += `${optionSet.id}-${optionSet.additionalCost}-${optionSet.quantity}`
    })
  })

  return comparisonId
}
